
import { Component } from "vue-property-decorator";
import Experiment from "@/components/ai/Experiment.vue";

@Component({})
/** プロンプトテンプレートお試し(看護計画書) */
export default class PromptTemplateExperiment extends Experiment {
  /** 関数 */

  created() {
    this.viewType = 1;
    this.experimentCondition.option.yearmonth = this.getCurrentYearmonth();
    this.fetchExperimentCondition();
  }

  /** お試しボタン押下時 */
  protected async beforeExperiment() {
    if (
      this.promptTemplate.blocks.findIndex(
        (block) => block.is_dataset_block && block.text == ""
      ) !== -1 &&
      this.useIbowData == 0
    ) {
      await this.$openAlert("手入力データが空欄です。");
      return;
    }

    if (
      !(await this.$openConfirm(
        "現在の入力内容でAIに問い合わせを行います。利用者データ挿入ブロックは手入力した内容が反映され、匿名化処理を適用した上でAIに送信されます。"
      ))
    ) {
      return;
    }

    this.experiment();
  }

  /** お試し */
  protected experiment() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/prompt/trial",
      {
        use_ibow_data: this.useIbowData,
        prompt_template: this.promptTemplate,
        experiment_condition: this.experimentCondition,
      },
      (res) => {
        this.experimentRes = res.data.experiment_res;
        this.experimentResViewer.open();
      }
    );
  }
}
